import * as React from "react";
export function SvgWarning(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width={14} height={14} {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FECA63"
          d="M6.206.987L.082 12.11c-.278.648.186 1.39.835 1.39h12.156c.742 0 1.113-.742.835-1.39L7.784.987c-.279-.65-1.207-.65-1.578 0z"
        />
        <path
          fill="#000"
          d="M7.642 10.72v.926H6.25v-.927h1.392zm0-6.49v5.562H6.25V4.231h1.392z"
        />
      </g>
    </svg>
  );
}
